/**
 * Textes de l'onglet « Reprise » de la fiche galerie (ARTO-126) : le mandat de
 * reprise, les lots, leur fiche et leurs rapports. Fichier à part pour ne pas
 * alourdir `i18n.ts` ; son bloc `reprise` est fusionné dans le namespace
 * `console` (D15). Voix 2.2 : phrases courtes, un geste porte le même nom du
 * bouton au message de fin.
 */

export const frReprise = {
  reprise: {
    titre: 'Reprise des données',
    reserve: 'La reprise est réservée à l’exploitation et à la direction de Venio.',
    chargement: 'Chargement…',
    natures: {
      oeuvres: 'Œuvres',
      lieux: 'Lieux',
      artistes: 'Artistes',
      contacts: 'Contacts',
      expositions: 'Expositions',
      'factures-historiques': 'Factures antérieures',
      documents: 'Documents',
      images: 'Images des œuvres',
      localisations: 'Localisations (historique)',
      provenance: 'Provenance',
      editions: 'Éditions (exemplaires)',
      membres: 'Membres de l’équipe',
    },
    etats: {
      depose: 'Déposé',
      profile: 'Profilé',
      transforme: 'Transformé',
      rapproche: 'Rapproché',
      essaye: 'Essayé, à corriger',
      pret: 'Prêt',
      enfile: 'En file',
      en_cours: 'En cours',
      termine: 'Terminé',
      echoue: 'Échoué',
      annule: 'Annulé',
      scelle: 'Scellé',
    },
    mandat: {
      titre: 'Mandat de reprise',
      texte:
        'Le mandat est l’accord de la galerie pour que Venio écrive chez elle. Sans lui, un lot se dépose mais ne s’essaie ni ne se lance. Il ne rend jamais une donnée lisible dans la console.',
      aucun: 'Aucun mandat en vigueur. Les essais et les lancements sont refusés.',
      actif: 'En vigueur',
      enAttente: 'En attente de la galerie',
      natures: 'Natures couvertes',
      confidentiels: 'Documents confidentiels',
      inclus: 'Inclus',
      exclus: 'Exclus',
      echeance: 'Jusqu’au {{date}}',
      origineContrat: 'Posé au contrat, référence {{reference}}',
      origineGalerie: 'Accordé par la galerie ({{email}})',
      demandeTexte_one:
        'Demandé par {{email}} pour {{count}} jour. Sans réponse, la demande expire le {{date}}.',
      demandeTexte_other:
        'Demandé par {{email}} pour {{count}} jours. Sans réponse, la demande expire le {{date}}.',
      motif: 'Motif : {{motif}}',
      demander: 'Demander un mandat',
      poser: 'Poser le mandat du contrat',
      revoquer: 'Révoquer le mandat',
      retirerDemande: 'Retirer la demande',
      revoquerTitre: 'Révoquer le mandat de reprise ?',
      revoquerTexte:
        'Les lots ne pourront plus s’essayer ni se lancer. Un lot déjà en file est abandonné sans rien écrire.',
      retirerTitre: 'Retirer la demande de mandat ?',
      retirerTexte: 'La galerie ne verra plus la demande dans sa régie.',
      annuler: 'Annuler',
      champNatures: 'Natures couvertes',
      champConfidentiels: 'Inclure les documents confidentiels',
      champMotif: 'Motif',
      aideMotif: 'Au moins 8 caractères.',
      champDuree: 'Durée en jours',
      aideDuree: '30 jours au plus.',
      champEcheance: 'Valable jusqu’au',
      champReference: 'Référence du devis ou du bon de commande',
      demandeTitre: 'Demander un mandat à la galerie',
      demandeAide:
        'La direction de la galerie accorde ou refuse la demande depuis sa régie. Un mandat accordé vaut 30 jours au plus.',
      poseTitre: 'Poser le mandat du contrat',
      poseAide:
        'À réserver au mandat prévu par le contrat signé. Un second facteur récent est exigé.',
      envoyer: 'Envoyer la demande',
      poserAction: 'Poser le mandat',
      demandeOk: 'Demande envoyée à la galerie.',
      poseOk: 'Mandat posé.',
      revoqueOk: 'Mandat révoqué.',
      retireOk: 'Demande retirée.',
      naturesRequises: 'Cochez au moins une nature.',
    },
    lots: {
      titre: 'Lots de reprise',
      texte:
        'Un lot réunit les fichiers d’une nature. Il s’essaie d’abord, sans rien écrire, puis se lance.',
      aucun: 'Aucun lot pour cette galerie. Déposez un premier lot pour commencer.',
      nouveau: 'Nouveau lot',
      limite: 'Les 100 lots les plus récents sont affichés.',
      colonnes: {
        nature: 'Nature',
        etat: 'État',
        compteurs: 'Résultat',
        operateur: 'Opérateur',
        depose: 'Déposé',
        action: 'Ouvrir',
      },
      ouvrir: 'Ouvrir le lot de {{nature}}',
      lignes_one: '{{count}} ligne',
      lignes_other: '{{count}} lignes',
      nonEssaye: 'Pas encore essayé',
      compteurs:
        '{{crees}} créées · {{completes}} complétées · {{ignores}} ignorées · {{refuses}} refusées',
      erreur: 'Impossible de lire les lots.',
    },
    depot: {
      titre: 'Nouveau lot',
      texte:
        'Déposez les fichiers du lot. Rien n’est écrit chez la galerie avant l’essai, puis le lancement.',
      nature: 'Nature des données',
      champs: {
        fichier: 'Tableur principal (CSV ou XLSX)',
        accrochages: 'Tableur des accrochages (CSV ou XLSX)',
        pdfs: 'PDF des factures (archive ZIP)',
        fichiers: 'Documents (archive ZIP)',
        images: 'Images (archive ZIP)',
      },
      facultatif: 'facultatif',
      confidentiels: 'Ces documents sont confidentiels',
      confidentielsAide:
        'Le mandat doit couvrir les documents confidentiels, et le lancement exige un second facteur récent.',
      motifInventaire: 'Motif d’inventaire',
      motifInventaireAide:
        'Facultatif, 60 caractères au plus. Dit pourquoi des numéros d’inventaire sont attribués.',
      gabarit: 'Télécharger le gabarit',
      gabaritAccrochages: 'Télécharger le gabarit des accrochages',
      deposer: 'Déposer le lot',
      annuler: 'Annuler',
      manquant: 'Joignez le fichier requis : {{champ}}.',
      ok: 'Lot déposé. Lancez un essai pour voir ce qu’il ferait.',
    },
    fiche: {
      retour: 'Retour aux lots',
      titre: 'Lot de {{nature}}',
      meta: 'Déposé le {{date}} par {{operateur}}',
      sources: 'Fichiers déposés',
      options: 'Options',
      confidentielsOui: 'Documents confidentiels',
      motifInventaire: 'Motif d’inventaire : {{motif}}',
      aucuneOption: 'Aucune option.',
      lignes: 'Lignes à reprendre',
      essayer: 'Essayer',
      essayerDeNouveau: 'Essayer de nouveau',
      essaiEnCours: 'Essai en cours…',
      lancer: 'Lancer',
      lancerAide: 'Le lancement n’est possible qu’après un essai sans ligne refusée.',
      corrigerAide:
        'L’essai a refusé des lignes. Corrigez les fichiers puis déposez un nouveau lot : un lot ne se modifie pas.',
      relancer: 'Relancer',
      suivi: 'Suivi du travail',
      tentative: 'Tentative {{tentatives}} sur {{max}}',
      rafraichi: 'La page se met à jour toutes les 3 secondes.',
      echec: 'Le travail a échoué. Vérifiez le journal de la galerie avant de relancer le lot.',
      termine: 'Le lot est terminé. Le rapport final ci-dessous fait foi.',
      confirmationTitre: 'Lancer ce lot ?',
      confirmationTexte_one:
        'Venio va écrire {{count}} ligne de {{nature}} chez la galerie, sous mandat.',
      confirmationTexte_other:
        'Venio va écrire {{count}} lignes de {{nature}} chez la galerie, sous mandat.',
      confirmationMfa:
        'Ce lot exige un second facteur récent : la vérification vous sera demandée.',
      annuler: 'Annuler',
      introuvable: 'Ce lot est introuvable.',
    },
    rapport: {
      titreEssai: 'Rapport d’essai',
      titreFinal: 'Rapport final',
      aideEssai: 'Rien n’a été enregistré : les nombres disent ce qui serait fait.',
      compteurs: 'Compteurs du rapport',
      total: 'Lignes lues',
      crees: 'Créées',
      completes: 'Complétées',
      ignores: 'Ignorées',
      refuses: 'Refusées',
      incoherent:
        'Les compteurs de ce rapport ne s’additionnent pas au total. Ne lancez pas le lot et signalez-le.',
      colonnesInconnues: 'Colonnes ignorées : {{liste}}',
      erreurs: 'Lignes refusées',
      avertissements: 'À vérifier',
      aucuneErreur: 'Aucune ligne refusée.',
      ligne: 'Ligne {{ligne}} · {{libelle}}',
      ligneAccrochage: 'Accrochages, ligne {{ligne}} · {{libelle}}',
      details: {
        imagesDeposees: 'Images déposées',
        imagesNonDeposees: 'Images non déposées',
        consentementsImportes: 'Consentements newsletter repris',
        retraitsAppliques: 'Désinscriptions appliquées',
        lignesAccrochages: 'Lignes d’accrochage lues',
        oeuvresAccrochees: 'Œuvres accrochées',
        accrochagesDejaPresents: 'Accrochages déjà présents',
        accrochagesRefuses: 'Lignes d’accrochage refusées',
      },
      listes: {
        artistesCrees: 'Artistes créés',
      },
      indisponible: 'Ce rapport est indisponible.',
    },
    depots: {
      titre: 'Dépôts de fichiers',
      texte:
        'Déposez l’export de l’ancien logiciel tel quel : des fichiers ou des dossiers entiers. Chaque fichier est relu (empreinte, type réel, antivirus) puis inventorié. Un dépôt n’écrit rien chez la galerie.',
      nouveau: 'Nouveau dépôt',
      libelle: 'Nom du dépôt',
      libelleAide: 'Par exemple « Export FileMaker du 12 octobre ».',
      plafond: 'Plafond (Gio)',
      plafondAide: '50 Gio par défaut, 200 au plus.',
      creer: 'Créer le dépôt',
      annuler: 'Annuler',
      aucun: 'Aucun dépôt pour cette galerie.',
      erreur: 'Les dépôts n’ont pas pu être chargés.',
      sansNom: 'Dépôt sans nom',
      parLien: 'Alimenté par un lien de dépôt',
      volume: '{{recus}} reçus sur {{plafond}}',
      fichiers_one: '{{count}} fichier',
      fichiers_other: '{{count}} fichiers',
      etats: {
        ouvert: 'Ouvert',
        ferme: 'Fermé',
        en_purge: 'Purge en cours',
        purge: 'Purgé',
      },
      inventaire: {
        vide: 'Rien reçu',
        a_faire: 'Inventaire en attente',
        en_cours: 'Inventaire en cours',
        fait: 'Inventorié',
        bloque: 'Analyse bloquée',
      },
      bloque:
        'L’antivirus ne répond pas : les fichiers attendent leur analyse et le dépôt n’est pas utilisable. Relancez l’inventaire quand il est revenu.',
      compteurs: '{{acceptes}} acceptés · {{refuses}} refusés · {{enAttente}} en attente',
      envoyer: 'Envoyer des fichiers',
      fermerEnvoi: 'Fermer l’envoi',
      relancer: 'Relancer l’inventaire',
      voirManifeste: 'Voir le manifeste',
      masquerManifeste: 'Masquer le manifeste',
      zone: {
        consigne: 'Glissez ici des fichiers ou des dossiers entiers : l’arborescence est gardée.',
        fichiers: 'Choisir des fichiers',
        dossier: 'Choisir un dossier',
      },
      envoi: {
        resume: '{{faits}} sur {{total}} fichiers reçus · {{envoyes}} sur {{volume}}',
        enCours: 'Envoi en cours…',
        fini: 'Envoi terminé : l’inventaire est lancé.',
        echecs_one: '{{count}} fichier n’est pas parti.',
        echecs_other: '{{count}} fichiers ne sont pas partis.',
        reprendre: 'Reprendre les envois interrompus',
        interrompre: 'Interrompre',
        reprise:
          'Après une coupure, choisissez de nouveau les mêmes fichiers : ce qui est déjà reçu ne repart pas.',
        etats: {
          attente: 'En attente',
          envoi: 'Envoi',
          termine: 'Reçu',
          erreur: 'Échec',
        },
        progression: 'Envoi de {{chemin}}',
        autres_one: 'et {{count}} autre fichier',
        autres_other: 'et {{count}} autres fichiers',
      },
      manifeste: {
        titre: 'Manifeste du dépôt',
        refuses: 'Refusés ({{count}})',
        acceptes: 'Acceptés ({{count}})',
        chemin: 'Chemin',
        taille: 'Taille',
        motif: 'Motif',
        aucun: 'Aucun fichier dans cette liste.',
        tronque: 'Seuls les {{count}} premiers sont affichés.',
        page: 'Page {{page}} sur {{pages}}',
        precedente: 'Page précédente',
        suivante: 'Page suivante',
        erreur: 'Le manifeste n’a pas pu être lu.',
      },
      motifs: {
        type_interdit: 'Type de fichier interdit',
        infecte: 'Signalé par l’antivirus',
        chemin_dangereux: 'Chemin dangereux',
        chemin_en_double: 'Chemin en double',
        archive_refusee: 'Archive illisible ou refusée',
        archive_trop_volumineuse: 'Archive de plus de 200 Mio : déposez le dossier décompressé',
        archive_imbriquee: 'Archive dans une archive',
        analyse_impossible: 'Trop volumineux pour l’antivirus',
        taille_incoherente: 'Taille incohérente',
        fichier_absent: 'Fichier absent du stockage',
        plafond_depasse: 'Plafond du dépôt atteint',
        en_attente_analyse: 'En attente de l’antivirus',
      },
    },
    liens: {
      titre: 'Liens de dépôt',
      texte:
        'Un lien permet à la galerie d’envoyer elle-même l’export de son ancien logiciel, sans compte. Il ne sert qu’à envoyer : rien ne s’y relit. Il expire au bout de 14 jours au plus, et vous recevez un accusé de réception.',
      nouveau: 'Créer un lien',
      libelle: 'Nom',
      plafond: 'Plafond (Gio)',
      duree: 'Durée (jours, 14 au plus)',
      creer: 'Créer le lien',
      annuler: 'Annuler',
      cree: 'Lien créé. Copiez-le maintenant : il ne sera plus affiché.',
      adresse: 'Adresse du lien',
      copier: 'Copier le lien',
      copie: 'Lien copié.',
      revoquer: 'Révoquer',
      revoquerTitre: 'Révoquer ce lien ?',
      revoquerTexte:
        'La page d’envoi cesse de fonctionner aussitôt. Les fichiers déjà reçus restent dans le dépôt.',
      revoquerConfirmer: 'Révoquer le lien',
      revoque: 'Lien révoqué.',
      aucun: 'Aucun lien de dépôt.',
      erreur: 'Les liens n’ont pas pu être chargés.',
      sansNom: 'Lien sans nom',
      etats: {
        actif: 'Actif',
        expire: 'Expiré',
        revoque: 'Révoqué',
      },
      echeance: 'Jusqu’au {{date}}',
      volume: '{{recus}} reçus sur {{plafond}}',
      auteur: 'Créé par {{email}}',
    },
    erreurs: {
      mandat_absent:
        'Aucun mandat de reprise en vigueur pour cette galerie. Demandez-en un, ou posez celui du contrat.',
      nature_hors_mandat:
        'Le mandat en vigueur ne couvre pas ce lot : sa nature, ou les documents confidentiels. Demandez un mandat plus large.',
      mfa_step_up_requis:
        'Une vérification récente du second facteur est requise pour lancer ce lot.',
      lot_non_pret: 'Le lot n’est pas prêt : lancez d’abord un essai sans ligne refusée.',
      essai_en_cours: 'Un essai de ce lot est déjà en cours.',
      lot_modifie: 'Le lot vient de changer. Rechargez la page.',
      lot_deja_lance: 'Ce lot est déjà lancé : il ne s’essaie plus.',
      module_inactif: 'Le module de cette nature n’est pas actif pour cette galerie.',
      fichier_requis: 'Joignez le tableur principal.',
      archive_requise: 'Joignez l’archive ZIP demandée.',
      depot_purge:
        'Le dépôt de ce lot est purgé, ou en cours de purge : ses fichiers ne se reprennent plus. Il faudra déposer de nouveau les fichiers.',
    },
  },
};

export const enReprise: typeof frReprise = {
  reprise: {
    titre: 'Data migration',
    reserve: 'Migration is reserved for Venio operations and management.',
    chargement: 'Loading…',
    natures: {
      oeuvres: 'Artworks',
      lieux: 'Locations',
      artistes: 'Artists',
      contacts: 'Contacts',
      expositions: 'Exhibitions',
      'factures-historiques': 'Earlier invoices',
      documents: 'Documents',
      images: 'Artwork images',
      localisations: 'Locations (history)',
      provenance: 'Provenance',
      editions: 'Editions (copies)',
      membres: 'Team members',
    },
    etats: {
      depose: 'Uploaded',
      profile: 'Profiled',
      transforme: 'Transformed',
      rapproche: 'Matched',
      essaye: 'Tried, needs fixes',
      pret: 'Ready',
      enfile: 'Queued',
      en_cours: 'Running',
      termine: 'Done',
      echoue: 'Failed',
      annule: 'Cancelled',
      scelle: 'Sealed',
    },
    mandat: {
      titre: 'Migration mandate',
      texte:
        'The mandate is the gallery’s consent for Venio to write into its data. Without it, a batch can be uploaded but neither tried nor launched. It never makes data readable in the console.',
      aucun: 'No mandate in force. Trials and launches are refused.',
      actif: 'In force',
      enAttente: 'Waiting for the gallery',
      natures: 'Data covered',
      confidentiels: 'Confidential documents',
      inclus: 'Included',
      exclus: 'Excluded',
      echeance: 'Until {{date}}',
      origineContrat: 'Set in the contract, reference {{reference}}',
      origineGalerie: 'Granted by the gallery ({{email}})',
      demandeTexte_one:
        'Requested by {{email}} for {{count}} day. If unanswered, the request expires on {{date}}.',
      demandeTexte_other:
        'Requested by {{email}} for {{count}} days. If unanswered, the request expires on {{date}}.',
      motif: 'Reason: {{motif}}',
      demander: 'Request a mandate',
      poser: 'Set the contract mandate',
      revoquer: 'Revoke the mandate',
      retirerDemande: 'Withdraw the request',
      revoquerTitre: 'Revoke the migration mandate?',
      revoquerTexte:
        'Batches can no longer be tried or launched. A batch already queued is abandoned without writing anything.',
      retirerTitre: 'Withdraw the mandate request?',
      retirerTexte: 'The gallery will no longer see the request in its back office.',
      annuler: 'Cancel',
      champNatures: 'Data covered',
      champConfidentiels: 'Include confidential documents',
      champMotif: 'Reason',
      aideMotif: 'At least 8 characters.',
      champDuree: 'Duration in days',
      aideDuree: '30 days at most.',
      champEcheance: 'Valid until',
      champReference: 'Quote or purchase order reference',
      demandeTitre: 'Request a mandate from the gallery',
      demandeAide:
        'The gallery’s management grants or refuses the request from its back office. A granted mandate lasts 30 days at most.',
      poseTitre: 'Set the contract mandate',
      poseAide:
        'Only for the mandate set out in the signed contract. A recent second factor is required.',
      envoyer: 'Send the request',
      poserAction: 'Set the mandate',
      demandeOk: 'Request sent to the gallery.',
      poseOk: 'Mandate set.',
      revoqueOk: 'Mandate revoked.',
      retireOk: 'Request withdrawn.',
      naturesRequises: 'Tick at least one kind of data.',
    },
    lots: {
      titre: 'Migration batches',
      texte:
        'A batch gathers the files of one kind of data. It is tried first, writing nothing, then launched.',
      aucun: 'No batch for this gallery. Upload a first batch to begin.',
      nouveau: 'New batch',
      limite: 'The 100 most recent batches are shown.',
      colonnes: {
        nature: 'Data',
        etat: 'State',
        compteurs: 'Result',
        operateur: 'Operator',
        depose: 'Uploaded',
        action: 'Open',
      },
      ouvrir: 'Open the {{nature}} batch',
      lignes_one: '{{count}} row',
      lignes_other: '{{count}} rows',
      nonEssaye: 'Not tried yet',
      compteurs:
        '{{crees}} created · {{completes}} completed · {{ignores}} skipped · {{refuses}} rejected',
      erreur: 'Could not read the batches.',
    },
    depot: {
      titre: 'New batch',
      texte:
        'Upload the batch files. Nothing is written to the gallery before the trial, then the launch.',
      nature: 'Kind of data',
      champs: {
        fichier: 'Main spreadsheet (CSV or XLSX)',
        accrochages: 'Hangings spreadsheet (CSV or XLSX)',
        pdfs: 'Invoice PDFs (ZIP archive)',
        fichiers: 'Documents (ZIP archive)',
        images: 'Images (ZIP archive)',
      },
      facultatif: 'optional',
      confidentiels: 'These documents are confidential',
      confidentielsAide:
        'The mandate must cover confidential documents, and launching requires a recent second factor.',
      motifInventaire: 'Inventory reason',
      motifInventaireAide:
        'Optional, 60 characters at most. Says why inventory numbers are assigned.',
      gabarit: 'Download the template',
      gabaritAccrochages: 'Download the hangings template',
      deposer: 'Upload the batch',
      annuler: 'Cancel',
      manquant: 'Attach the required file: {{champ}}.',
      ok: 'Batch uploaded. Run a trial to see what it would do.',
    },
    fiche: {
      retour: 'Back to batches',
      titre: '{{nature}} batch',
      meta: 'Uploaded on {{date}} by {{operateur}}',
      sources: 'Uploaded files',
      options: 'Options',
      confidentielsOui: 'Confidential documents',
      motifInventaire: 'Inventory reason: {{motif}}',
      aucuneOption: 'No options.',
      lignes: 'Rows to import',
      essayer: 'Try',
      essayerDeNouveau: 'Try again',
      essaiEnCours: 'Trial running…',
      lancer: 'Launch',
      lancerAide: 'Launching is only possible after a trial with no rejected row.',
      corrigerAide:
        'The trial rejected rows. Fix the files and upload a new batch: a batch cannot be edited.',
      relancer: 'Run again',
      suivi: 'Job progress',
      tentative: 'Attempt {{tentatives}} of {{max}}',
      rafraichi: 'The page updates every 3 seconds.',
      echec: 'The job failed. Check the gallery’s log before running the batch again.',
      termine: 'The batch is done. The final report below is authoritative.',
      confirmationTitre: 'Launch this batch?',
      confirmationTexte_one:
        'Venio will write {{count}} row of {{nature}} into the gallery, under mandate.',
      confirmationTexte_other:
        'Venio will write {{count}} rows of {{nature}} into the gallery, under mandate.',
      confirmationMfa: 'This batch requires a recent second factor: you will be asked to verify.',
      annuler: 'Cancel',
      introuvable: 'This batch cannot be found.',
    },
    rapport: {
      titreEssai: 'Trial report',
      titreFinal: 'Final report',
      aideEssai: 'Nothing was saved: the numbers say what would be done.',
      compteurs: 'Report counters',
      total: 'Rows read',
      crees: 'Created',
      completes: 'Completed',
      ignores: 'Skipped',
      refuses: 'Rejected',
      incoherent:
        'The counters of this report do not add up to the total. Do not launch the batch, and report it.',
      colonnesInconnues: 'Ignored columns: {{liste}}',
      erreurs: 'Rejected rows',
      avertissements: 'To check',
      aucuneErreur: 'No rejected row.',
      ligne: 'Row {{ligne}} · {{libelle}}',
      ligneAccrochage: 'Hangings, row {{ligne}} · {{libelle}}',
      details: {
        imagesDeposees: 'Images uploaded',
        imagesNonDeposees: 'Images not uploaded',
        consentementsImportes: 'Newsletter consents kept',
        retraitsAppliques: 'Unsubscriptions applied',
        lignesAccrochages: 'Hanging rows read',
        oeuvresAccrochees: 'Works hung',
        accrochagesDejaPresents: 'Hangings already present',
        accrochagesRefuses: 'Hanging rows rejected',
      },
      listes: {
        artistesCrees: 'Artists created',
      },
      indisponible: 'This report is unavailable.',
    },
    depots: {
      titre: 'File uploads',
      texte:
        'Upload the export of the former software as it is: files or whole folders. Each file is read again (fingerprint, real type, antivirus) then inventoried. An upload writes nothing into the gallery.',
      nouveau: 'New upload',
      libelle: 'Upload name',
      libelleAide: 'For instance “FileMaker export of 12 October”.',
      plafond: 'Limit (GiB)',
      plafondAide: '50 GiB by default, 200 at most.',
      creer: 'Create the upload',
      annuler: 'Cancel',
      aucun: 'No upload for this gallery.',
      erreur: 'The uploads could not be loaded.',
      sansNom: 'Unnamed upload',
      parLien: 'Fed by an upload link',
      volume: '{{recus}} received out of {{plafond}}',
      fichiers_one: '{{count}} file',
      fichiers_other: '{{count}} files',
      etats: {
        ouvert: 'Open',
        ferme: 'Closed',
        en_purge: 'Being purged',
        purge: 'Purged',
      },
      inventaire: {
        vide: 'Nothing received',
        a_faire: 'Inventory pending',
        en_cours: 'Inventory running',
        fait: 'Inventoried',
        bloque: 'Scan blocked',
      },
      bloque:
        'The antivirus does not answer: the files await their scan and the upload cannot be used. Run the inventory again once it is back.',
      compteurs: '{{acceptes}} accepted · {{refuses}} refused · {{enAttente}} pending',
      envoyer: 'Upload files',
      fermerEnvoi: 'Close the upload panel',
      relancer: 'Run the inventory again',
      voirManifeste: 'Show the manifest',
      masquerManifeste: 'Hide the manifest',
      zone: {
        consigne: 'Drop files or whole folders here: the folder tree is kept.',
        fichiers: 'Choose files',
        dossier: 'Choose a folder',
      },
      envoi: {
        resume: '{{faits}} of {{total}} files received · {{envoyes}} of {{volume}}',
        enCours: 'Uploading…',
        fini: 'Upload complete: the inventory has started.',
        echecs_one: '{{count}} file was not sent.',
        echecs_other: '{{count}} files were not sent.',
        reprendre: 'Resume interrupted uploads',
        interrompre: 'Stop',
        reprise:
          'After a cut, choose the same files again: what was already received is not sent twice.',
        etats: {
          attente: 'Waiting',
          envoi: 'Sending',
          termine: 'Received',
          erreur: 'Failed',
        },
        progression: 'Uploading {{chemin}}',
        autres_one: 'and {{count}} other file',
        autres_other: 'and {{count}} other files',
      },
      manifeste: {
        titre: 'Upload manifest',
        refuses: 'Refused ({{count}})',
        acceptes: 'Accepted ({{count}})',
        chemin: 'Path',
        taille: 'Size',
        motif: 'Reason',
        aucun: 'No file in this list.',
        tronque: 'Only the first {{count}} are shown.',
        page: 'Page {{page}} of {{pages}}',
        precedente: 'Previous page',
        suivante: 'Next page',
        erreur: 'The manifest could not be read.',
      },
      motifs: {
        type_interdit: 'Forbidden file type',
        infecte: 'Flagged by the antivirus',
        chemin_dangereux: 'Unsafe path',
        chemin_en_double: 'Duplicate path',
        archive_refusee: 'Unreadable or refused archive',
        archive_trop_volumineuse: 'Archive over 200 MiB: upload the unzipped folder',
        archive_imbriquee: 'Archive inside an archive',
        analyse_impossible: 'Too large for the antivirus',
        taille_incoherente: 'Inconsistent size',
        fichier_absent: 'File missing from storage',
        plafond_depasse: 'Upload limit reached',
        en_attente_analyse: 'Awaiting the antivirus',
      },
    },
    liens: {
      titre: 'Upload links',
      texte:
        'A link lets the gallery send the export of its former software itself, without an account. It is for sending only: nothing can be read back through it. It expires after 14 days at most, and you receive an acknowledgement.',
      nouveau: 'Create a link',
      libelle: 'Name',
      plafond: 'Limit (GiB)',
      duree: 'Duration (days, 14 at most)',
      creer: 'Create the link',
      annuler: 'Cancel',
      cree: 'Link created. Copy it now: it will not be shown again.',
      adresse: 'Link address',
      copier: 'Copy the link',
      copie: 'Link copied.',
      revoquer: 'Revoke',
      revoquerTitre: 'Revoke this link?',
      revoquerTexte:
        'The upload page stops working at once. Files already received stay in the upload.',
      revoquerConfirmer: 'Revoke the link',
      revoque: 'Link revoked.',
      aucun: 'No upload link.',
      erreur: 'The links could not be loaded.',
      sansNom: 'Unnamed link',
      etats: {
        actif: 'Active',
        expire: 'Expired',
        revoque: 'Revoked',
      },
      echeance: 'Until {{date}}',
      volume: '{{recus}} received out of {{plafond}}',
      auteur: 'Created by {{email}}',
    },
    erreurs: {
      mandat_absent:
        'No migration mandate in force for this gallery. Request one, or set the contract mandate.',
      nature_hors_mandat:
        'The mandate in force does not cover this batch: its kind of data, or confidential documents. Request a wider mandate.',
      mfa_step_up_requis: 'A recent second-factor check is required to launch this batch.',
      lot_non_pret: 'The batch is not ready: run a trial with no rejected row first.',
      essai_en_cours: 'A trial of this batch is already running.',
      lot_modifie: 'The batch just changed. Reload the page.',
      lot_deja_lance: 'This batch is already launched: it can no longer be tried.',
      module_inactif: 'The module for this kind of data is not active for this gallery.',
      fichier_requis: 'Attach the main spreadsheet.',
      archive_requise: 'Attach the requested ZIP archive.',
      depot_purge:
        'This batch’s upload is purged, or being purged: its files can no longer be taken. The files will have to be uploaded again.',
    },
  },
};
